import { render } from "./newly.vue?vue&type=template&id=b70eba42&scoped=true"
import script from "./newly.vue?vue&type=script&lang=js"
export * from "./newly.vue?vue&type=script&lang=js"

import "./newly.vue?vue&type=style&index=0&id=b70eba42&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70eba42"]])

export default __exports__